<script setup>
import { useI18n } from 'vue-i18n';
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  show: { type: Boolean, default: false },
});
const emit = defineEmits(['close', 'confirm']);
const { t } = useI18n();
</script>

<template>
  <LaisModal
    :show="show"
    max-width-class="max-w-[760px]"
    @close="emit('close')"
  >
    <div class="grid gap-6 p-2 sm:grid-cols-[160px_1fr] sm:items-center">
      <div
        class="mx-auto grid size-32 place-items-center rounded-lais-xl bg-lais-primary-50 text-lais-primary"
      >
        <span class="i-lucide-badge-check size-16" aria-hidden="true" />
      </div>
      <div>
        <h2 class="font-redHatDisplay text-2xl font-bold text-lais-text">
          {{ t('SALES.REVIEW.CONFIRMATION.TITLE') }}
        </h2>
        <p class="mt-4 text-sm text-lais-text-body">
          {{ t('SALES.REVIEW.CONFIRMATION.DESCRIPTION') }}
          <strong>{{ t('SALES.REVIEW.CONFIRMATION.STATUS') }}</strong>
        </p>
        <p class="mt-6 text-sm font-bold text-lais-text-body">
          {{ t('SALES.REVIEW.CONFIRMATION.THANKS') }}
        </p>
      </div>
    </div>
    <template #footer>
      <div class="flex justify-end">
        <LaisPrimaryButton
          size="lg"
          icon="i-lucide-check"
          @click="emit('confirm')"
        >
          {{ t('SALES.REVIEW.CONFIRMATION.ACTION') }}
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisModal>
</template>
